import { useEffect } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { TransactionDocuments } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { setPanelIsOpen } from '../../../store/slices/problem-transactions/internal-transaction';
import useProblemIncomingTransaction from '../hooks/use-incoming';

const IncomingTransactionDocuments = () => {
  const { transaction, documents, documentsPagination } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const dispatch = useAppDispatch();

  const { transactionId } = useParams();

  const {
    downloadFileIsSuccess,
    downloadInProgress,
    downloadIsFetching,
    onDownloadDocument,
    selectedDocumentId,
    setSelectedDocumentId,
    setUploadedFilesError,
    onUploadDocument,
    fileUploadInProgress,
    addDocumentInProgress,
    fileUploadIsSuccess,
    uploadedFilesError,
    documentsIsFetching,
    getTransationDocumentsAction,
  } = useProblemIncomingTransaction({
    transactionId,
    transaction,
  });

  const {
    setSubPanelVisible,
    setSelectedDocumentName,
    getTransactionDocument,
  } = useOutletContext<{
    setSubPanelVisible: (data: boolean) => void;
    setSelectedDocumentName: (data: string) => void;
    getTransactionDocument: (data: string) => void;
  }>();

  const setTransactionSidepanelVisible = (data: boolean) => {
    dispatch(setPanelIsOpen(data));
  };

  useEffect(() => {
    if (downloadFileIsSuccess && selectedDocumentId && !downloadInProgress) {
      setSelectedDocumentId('');
    }
  }, [downloadFileIsSuccess, selectedDocumentId, downloadInProgress]);

  useEffect(
    () => () => {
      setSelectedDocumentId('');
      setUploadedFilesError([]);
    },
    [],
  );

  return (
    <TransactionDocuments
      documents={documents}
      setSubPanelVisible={setSubPanelVisible}
      setSelectedDocumentName={setSelectedDocumentName}
      setTransactionSidepanelVisible={setTransactionSidepanelVisible}
      onUploadDocument={onUploadDocument}
      uploadDocumentInProgress={fileUploadInProgress || addDocumentInProgress}
      uploadDocumentIsSuccess={fileUploadIsSuccess}
      uploadDocumentErrors={uploadedFilesError}
      selectedDocumentId={selectedDocumentId}
      setSelectedDocumentId={setSelectedDocumentId}
      downloadInProgress={downloadInProgress || downloadIsFetching}
      senderAccount={transaction?.senderAccount}
      recipientAccount={transaction?.recipientAccount}
      onDownloadDocument={onDownloadDocument}
      activePermission={activePermissions}
      getTransactionDocument={getTransactionDocument}
      documentsPagination={documentsPagination}
      documentsIsFetching={documentsIsFetching}
      getTransactionDocuments={getTransationDocumentsAction}
    />
  );
};

export default IncomingTransactionDocuments;
